<header class="header d-flex justify-content-between align-items-center">
  <span class="d-flex d-lg-none d-flex justify-content-center align-items-center" (click)="actionNavToggle()">
    <div class="hamburger d-flex d-lg-none">
      <span class="bar"></span>
    </div>
  </span>
    <div class="title_column">
        <svg-icon class="mr-2" src="assets/svg/logo.svg"></svg-icon>
        <h3 class="text-white m-0">| Atestado Médico</h3>
    </div>

    <div class="d-none d-lg-flex">
        <a href="#" class="d-none d-lg-block header__user">
            <span>{{'headerSalutation' | translate}}, <strong>{{user.name}}</strong></span>
            <img src="{{!user?.photo ? 'assets/images/user.png' : user?.photo}}"
                 class="profile_photo"/>
        </a>
        <div class="header__btn">
            <app-notification></app-notification>
        </div>
        <div class="header__btn pr-0">
            <font class="header_font">{{'idioma' | translate}}:</font>
            <a class="header_font" href="javascript:void('');" [ngClass]="{'active' : translate.currentLang === 'pt'}"
               (click)="switchLanguage('pt')">PT</a>
            <span class="separator">|</span>
            <a class="header_font" href="javascript:void('');" [ngClass]="{'active' : translate.currentLang === 'es'}"
               (click)="switchLanguage('es')">ES</a>
        </div>
        <div class="header__btn">
            <a href="javascript:void('sair');" [routerLink]="['/logout']" class="d-none d-lg-flex header__user__outbtn">
                <strong class="header__user__outbtn__text">{{'sair' | translate}}</strong>
            </a>
        </div>
    </div>
</header>
